import React from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbSelect from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_select'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbCheckbox from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_checkbox'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import MDefaultform from '../m_defaultForm'
import { extractFields } from '../../../../../../utils/form/extractFields'
import { emailRegex } from '../../../../../../utils/form/emailRegex'

const MCupOfFansRegistration = ({ data }) => {
  const t = useTranslations()

  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)

  const selectPosition = {
    identifier: 'position',
    label: 'Bitte Ihre Position wählen',
    values: [
      {
        id: 0,
        name: 'Torwart',
      },
      {
        id: 1,
        name: 'Abwehr',
      },
      {
        id: 2,
        name: 'Mittelfeld',
      },
      {
        id: 3,
        name: 'Stürmer',
      },
    ],
  }

  return (
    <MDefaultform
      buttonLabel="Absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      formType={formType}
      shouldPersist={data.form_definition[0].save_in_db}
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}
          {data.text && <DfbParagraph add_class="m-Formblock-text" text={data.text} />}
          {(fields.firstname || fields.lastname || fields.email) && (
            <div className="m-Formblock-row-third">
              {[fields.firstname, fields.lastname, fields.email].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-row-third-cell" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      pattern:
                        formItem.identifier === fields.email?.identifier
                          ? {
                              value: emailRegex,
                              message: t('form.errorMessage.emailPattern'),
                            }
                          : undefined,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}
          {(fields.phone || fields.mobile) && (
            <div className="m-Formblock-input-half">
              {[fields.phone, fields.mobile].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}
          <div className="m-Formblock-spacer"></div>
          {(fields.birthofdate || selectPosition.values.length > 0) && (
            <div className="m-Formblock-input-half">
              {fields.birthofdate && (
                <div className="m-Formblock-input">
                  <DfbInput
                    {...register(fields.birthofdate.identifier, {
                      required: fields.birthofdate.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[fields.birthofdate.identifier]}
                    errorMessage={errors?.[fields.birthofdate.identifier]?.message}
                    label={`${fields.birthofdate.label}${fields.birthofdate.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              )}
              {selectPosition.values.length >= 0 && (
                <div className="m-Formblock-input">
                  <DfbSelect
                    {...register('position', {
                      required: t('form.errorMessage.select'),
                    })}
                    label={selectPosition.label}
                    options={selectPosition.values.length >= 1 ? selectPosition.values : selectPosition.values[0]}
                    placeholder={t('form.placeholder.select')}
                    errorMessage={errors?.position?.message}
                    error={errors['position']}
                  />
                </div>
              )}
            </div>
          )}
          <div className="m-Formblock-input">
            <DfbInput
              {...register(fields.membernumber.identifier, {
                required: fields.membernumber.required ? t('form.errorMessage.input') : false,
              })}
              error={errors[fields.membernumber.identifier]}
              errorMessage={errors?.[fields.membernumber.identifier]?.message}
              label={`${fields.membernumber.label}${fields.membernumber.required === 1 ? '*' : ''}`}
              focused
            />
          </div>
          <div className="m-Formblock-spacer"></div>
          {fields.dataprotection && (
            <div className="m-Formblock-checkbox">
              <DfbCheckbox
                text={t('form.privacyText')}
                {...register(fields.dataprotection.identifier, {
                  required: true,
                })}
                error={errors[fields.dataprotection.identifier]}
              />
            </div>
          )}
          {fields.confirmation && (
            <div className="m-Formblock-checkbox">
              <DfbCheckbox
                text={t('form.cupOfFans.confirmationText')}
                {...register(fields.confirmation.identifier, {
                  required: true,
                })}
                error={errors[fields.confirmation.identifier]}
              />
            </div>
          )}
        </>
      )}
    </MDefaultform>
  )
}

export default MCupOfFansRegistration
